(function () {
  let lastPercentage = 0;
  const seenBars = new WeakSet();

  function getTargetPercentage(bar) {
    const raw = bar.dataset.progressPercentage;
    const value = parseFloat(raw);
    return isNaN(value) ? 0 : Math.min(Math.max(value, 0), 100);
  }

  function fillBar(bar, fromPercentage) {
    const target = getTargetPercentage(bar);

    const effectiveFrom = seenBars.has(bar) ? fromPercentage : 0;

    if (target === effectiveFrom) {
      seenBars.add(bar);
      return;
    }

    if (target >= 100) {
      bar.style.transition = "none";
      bar.style.width = target + "%";
      lastPercentage = target;
      seenBars.add(bar);
      return;
    }

    bar.style.transition = "none";
    bar.style.width = effectiveFrom + "%";

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        bar.style.transition = "";
        bar.style.width = target + "%";
        lastPercentage = target;
        seenBars.add(bar);
      });
    });
  }

  function fillAllBars(fromPercentage) {
    document.querySelectorAll(".progress-status__bar").forEach((bar) => {
      fillBar(bar, fromPercentage);
    });
  }

  function isCartDrawerEvent(event) {
    return (
      event.target instanceof HTMLElement && event.target.id === "cart-drawer"
    );
  }

  function isCartDrawerOpen() {
    const drawer = document.getElementById("cart-drawer");
    return !!(drawer && drawer.hasAttribute("open"));
  }

  let syncScheduled = false;
  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(() => {
      syncScheduled = false;
      if (isCartDrawerOpen()) {
        fillAllBars(lastPercentage);
      }
    });
  }

  document.addEventListener("theme-drawer:open", (event) => {
    if (isCartDrawerEvent(event)) {
      fillAllBars(0);
    }
  });

  if (isCartDrawerOpen()) {
    fillAllBars(0);
  }

  const cartDrawer = document.getElementById("cart-drawer");
  if (cartDrawer) {
    new MutationObserver(() => scheduleSync()).observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-progress-percentage"],
    });
  }
})();
